import { render, staticRenderFns } from "./CellRendererGameActions.vue?vue&type=template&id=74cfe304&"
import script from "./CellRendererGameActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererGameActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports